import React, { FC } from 'react';
import styled from 'styled-components';

import { Button } from '~/atomic/atom/Button';
import { SearchBooksLink } from '~/atomic/atom/links/dynamicLinks';
import { TextBoldStyle, TextRegStyle } from '~/atomic/Typography';

export const EmptyCatalogPage: FC = () => {
  return (
    <SCEmptyCatalogPage>
      <SCImage
        src="/icon/gray-search.svg"
        alt="иконка увеличительного стекла"
      />
      <SCTitle> Эта библиотека пока пустует </SCTitle>
      <SCMessage>
        К сожалению, ни один автор еще не разместил здесь своих произведений. Загляните в другие
        разделы Библиотеки или воспользуйтесь поиском по жанрам или тегам,
        чтобы найти произведение по душе
      </SCMessage>
      <SearchBooksLink>
        <a>
          <Button type="primary">
            Отправиться на поиски
          </Button>
        </a>
      </SearchBooksLink>
    </SCEmptyCatalogPage>
  );
};

const SCEmptyCatalogPage = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SCImage = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 18px;
`;

const SCMessage = styled.span`
  ${TextRegStyle};
  margin-bottom: 18px;
  max-width: 514px;
  text-align: center;                
`;

const SCLink = styled.a`
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 18px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const SCTitle = styled.span`
  ${TextBoldStyle};
  margin-bottom: 18px;
  color: var(--color-black);
`;
